import connectToStores from 'alt-utils/lib/connectToStores'
import { ExtendedUserActions, SearchConsoleActions } from 'actions'
import { SearchConsoleStore } from 'stores'
import { Nav, Button } from 'components'
import { GOOGLE_OAUTH2_PATH, API_BASE, GOOGLE_SEARCH_CONSOLE_PERMISSION_UNVERIFIED, GOOGLE_SEARCH_CONSOLE_SETUP_URL} from 'consts'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Helmet from 'react-helmet'
import FontIcon from 'material-ui/FontIcon'
import AccessRevokedError from '../components/search_console/partials/AccessRevokedError'
import SiteUnverifiedError from '../components/search_console/partials/SiteUnverifiedError'
import GenericError from '../components/search_console/partials/GenericError'
import { AnalyticsUtils } from 'utils'

import './editSearchConsoleContainer.scss'

@connectToStores
export default class EditSearchConsoleContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [SearchConsoleStore]
  }

  static getPropsFromStores() {
    return SearchConsoleStore.getState()
  }

  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      listSitesError: null,
      fetchingListSites: true
    }

    this.save = this.save.bind(this)
    this.handleSelectSite = this.handleSelectSite.bind(this)
  }

  fetchListSites() {
    this.setState({ listSitesError: null, fetchingListSites: true })

    SearchConsoleActions.listSites()
      .catch((listSitesError) => this.setState({ listSitesError }))
      .finally(() => { this.setState({ fetchingListSites: false }) })
  }

  componentWillMount() {
    const queryParams = this.props.location.query
    if (!this.isSignedIn() && queryParams['auto-fetch'] !== 'true') return

    this.fetchListSites()
  }

  renderSignedIn() {
    return (
      <div>
        { this.renderHeading() }
        { this.maybeRenderLoading() || this.maybeRenderError() || this.renderSuccess() }
      </div>
    )
  }

  renderLoading() {
    return <div>Loading…</div>
  }

  maybeRenderLoading() {
    return this.state.fetchingListSites && this.renderLoading()
  }

  renderError() {
    const error = this.state.listSitesError.response.data.error
    if (!error) return this.renderErrorGeneric()

    switch(error.message) {
      case "invalid_grant":
      case "invalid_token":
      case "invalid_credentials":
        return this.renderErrorAccessRevoked()
      default:
        return this.renderErrorGeneric()
    }
  }

  renderErrorAccessRevoked() {
    return <AccessRevokedError user={this.context.currentUser}/>
  }

  renderErrorGeneric() {
    return <GenericError user={this.context.currentUser} onRefresh={::this.fetchListSites} />
  }

  renderWarningSiteUnverified() {
    return <SiteUnverifiedError user={this.context.currentUser} site={this.context.currentUser.searchConsoleSite} />
  }

  maybeRenderWarningSiteUnverified() {
    const userSite = this.context.currentUser.searchConsoleSite
    const selectedSite = this.props.listedSites.data.find(x => x.siteUrl === userSite)

    if (!selectedSite || selectedSite.permissionLevel !== GOOGLE_SEARCH_CONSOLE_PERMISSION_UNVERIFIED) return

    return this.renderWarningSiteUnverified()
  }

  maybeRenderError() {
    return this.state.listSitesError && this.renderError()
  }

  renderSuccess() {
    return (
      <div>
        <div className="flex-center--horizontal">
          <FontIcon className="material-icons small-spacing2--right mall-spacing2--bottom green">check</FontIcon>
          <p className="body2">
            Connected as { this.context.currentUser.googleUserEmail }
          </p>
        </div>
        { this.maybeRenderWarningSiteUnverified() }
        <div className="large-spacing--top">
          <h4>Shop Website</h4>
          <SelectField
            hintText="Select a site"
            onChange={this.handleSelectSite}
            value={this.context.currentUser.searchConsoleSite}
          >
            {this.props.listedSites.data.map(k => {
              return <MenuItem
                style={k.permissionLevel == GOOGLE_SEARCH_CONSOLE_PERMISSION_UNVERIFIED && { color: "#FF4141"} || {}}
                key={k.siteUrl}
                value={k.siteUrl}
                primaryText={k.siteUrl.replace(/^sc-domain:/, "")} />
            })}
          </SelectField>
          <p className="body2 large-spacing2--top">Don't see your website listed here? <a href="https://search.google.com/search-console/about" target="_blank">Set up Google Search Console.</a></p>
        </div>
      </div>
    )
  }

  renderNotSignedIn() {
    return (
      <div>
        { this.renderHeading() }
        <p className="body2">
          Track your SEO progress inside Plug in SEO by connecting your Google Search Console account
        </p>
        <div className="edit-search-console__body large-spacing--top">
          <Button
            label="Connect to Search Console"
            buttonType="secondary"
            onTouchTap={::this.handleConnectToSearchConsole}
          />
        </div>
        <p className="body2 xlarge-spacing2--top">
          Don't have a Google Search Console account? <a onTouchTap={::this.handleSetupSearchConsoleAccount}>Set up one up here.</a>
        </p>
      </div>
    )
  }

  handleSetupSearchConsoleAccount() {
    window.open(GOOGLE_SEARCH_CONSOLE_SETUP_URL, "_blank")

    AnalyticsUtils.clickedSetupSearchConsoleAccount(this.context.currentUser.email)
  }

  save(newState) {
    this.setState(
      {
        fieldsEnabled: false,
        saving: true
      }
    )
    ExtendedUserActions.update(newState).then(() => this.setState({ fieldsEnabled: true, saving: false }))
  }

  handleConnectToSearchConsole() {
    AnalyticsUtils.startedGoogleAccountConnection(this.context.currentUser.email)
    window.location = `${API_BASE}${GOOGLE_OAUTH2_PATH}`
  }

  handleSelectSite(_event, _key, value) {
    this.save({ search_console_site: value })
  }

  renderHeading() {
    return (
      <div className="edit-search-console__header small-spacing--bottom">
        <h2 className="small-spacing--bottom">Google Search Console</h2>
        { this.state.saving && <span className="saving-indicator">Saving…</span> }
      </div>
    )
  }

  isSignedIn() {
    return !!this.context.currentUser.googleUserEmail
  }

  render() {
    return (
      <div>
        <div>
          <Helmet title="Google Search Console - Plug in SEO Plus" />
          <Nav toolbarTitleText="Google Search Console" backRoute="/plus/trends" />
        </div>
        <div className='seosettings'>
          <div className="seosettings__form-container">
            <div className='seosettings__row edit-search-console'>
              { this.isSignedIn() && this.renderSignedIn() || this.renderNotSignedIn() }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/EditSearchConsoleContainer.js